export const LEAD_STATUSES = {
  appointed: 'APPOINTED', // В работе
  new: 'NEW', // Новый
  expired: 'EXPIRED', // Просрочено
  failure: 'FAILURE', // Сделка не состоялась
  won: 'WON', // Выиграл
  closed: 'CLOSED', // Партнер отказался
  failReasonErroring: 'FAIL_REASON_ERRORING', // Сделка не состоялась: Ошибочно принял
  failReasonUncompatible: 'FAIL_REASON_UNCOMPATIBLE', // Сделка не состоялась: Недостаточно компетенций / Нет возможности отработать
  leadAutoAssign: 'LEAD_AUTO_ASSIGN', // Автоматическое назначение лида
  leadHandleAssign: 'LEAD_HANDLE_ASSIGN', // Лид назначем менеджером вручную
  leadExpiredIfNotAccepted: 'LEAD_EXPIRED_IFNOT_ACCEPTED', // Лид не приняли и просрочили.
  leadExpiredIfAccepted: 'LEAD_EXPIRED_IF_ACCEPTED', // Лид принимали и просрочили.
}

export const LEAD_STATUS_YII = {
  [LEAD_STATUSES.appointed]: 1,
  [LEAD_STATUSES.new]: 2,
  [LEAD_STATUSES.expired]: 3,
  [LEAD_STATUSES.failure]: 4,
  [LEAD_STATUSES.won]: 5,
  [LEAD_STATUSES.closed]: 6,
  [LEAD_STATUSES.failReasonErroring]: 6,
  [LEAD_STATUSES.failReasonUncompatible]: 7,
  [LEAD_STATUSES.leadAutoAssign]: 1,
  [LEAD_STATUSES.leadHandleAssign]: 2,
  [LEAD_STATUSES.leadExpiredIfNotAccepted]: 863280006,
  [LEAD_STATUSES.leadExpiredIfAccepted]: 863280007,
}

export const LEAD_STATUS_FRONT = {
  [LEAD_STATUSES.appointed]: 1,
  [LEAD_STATUSES.new]: 0,
  [LEAD_STATUSES.expired]: 4,
  [LEAD_STATUSES.failure]: 3,
  [LEAD_STATUSES.won]: 2,
}



// WEBPACK FOOTER //
// ./src/templates/pages/lk/leads/consts/lead.status.js